export default "__VITE_ASSET__C9Ol1_Xx__"